import { render, staticRenderFns } from "./PermissionRecordVersions.vue?vue&type=template&id=2c790c80"
import script from "./PermissionRecordVersions.vue?vue&type=script&lang=js"
export * from "./PermissionRecordVersions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c790c80')) {
      api.createRecord('2c790c80', component.options)
    } else {
      api.reload('2c790c80', component.options)
    }
    module.hot.accept("./PermissionRecordVersions.vue?vue&type=template&id=2c790c80", function () {
      api.rerender('2c790c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/permissionrecord/PermissionRecordVersions.vue"
export default component.exports